import { ClickAwayListener } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { textcss } from '../../../common/CSS';


export function GoogleInput(props) {
  let { className, inputcln, type, label, value, name, placeholder, onKeyPress, onBlurHandler = () => { }, onChangeHandler, errorMessage, required, error, place_i, setplace_id, errors, options, setFormSubmit } = props

  useEffect( () => {
    if(options.length > 0 ){
       setplace_id({ ...place_i, onOff : true})
    }else if (options.length === 0){
       setplace_id({ ...place_i, onOff : false})
    }
   
  } , [options])

  const handleSubmit = (e) => {
    let event = {
        "target" : {
          "value" : e.value ,
          "name" : name
        }
    }

    onChangeHandler(event, errorMessage)
    setplace_id({
      onOff : false,
      placeId : e.label
    })
    setFormSubmit(true)
  }

  const closeDropdown = () => {
    if(place_i.onOff){
      setplace_id({ ...place_i, onOff : false})
    }else if(place_i.onOff === false){ 
      setplace_id({ ...place_i, onOff : true})
    }
  }

  const closeDropdownOutSideDropdown = () => {
    setplace_id({ ...place_i, onOff: false })
  }

  return (
    <ClickAwayListener onClickAway={() => { place_i.onOff && closeDropdownOutSideDropdown() }}>
      <div className={`px-1 pt-1 mt-2 ${className} `} >
            <label  className="block border-b-2 ">
                <p className={textcss?.labelClass}> {label} { required && <span>*</span>} </p>
                <div className="flex items-center" >
                <input autoComplete='off' type={type} required={required} className={` ${textcss.inputClass} ${inputcln}`} value={value} name={name} onKeyPress={onKeyPress} onChange={(event) => { onChangeHandler(event, errorMessage) 
                  setplace_id({
                    onOff : true,
                    place_Id : ""
                  })
                }}  onBlur={(event) => { onBlurHandler(event, errorMessage) }} placeholder={placeholder} />
                {options.length > 0 ? <span onClick={()=> closeDropdown()} className="material-icons ">{place_i.onOff ? "arrow_drop_up" : "arrow_drop_down"}</span> : ""}
                </div>
            </label>

            <div
          className={`dropdown-items z-40 ${
            place_i.onOff ? "isVisible" : "isHidden"
          }`}
        >
          {options?.map((e, i) => {
            return(
              <div key={i} onClick={() => handleSubmit(e)} className="dropdown-item pl-2 border border-bottom-1 hover:bg-scogoBgBrop">
              <div
                  className="dropdown__link"
              >
                {e.value}
              </div>
            </div>
            )
          })}
          
        </div>

            {errors?.[name] && <span className="text-scogoRed text-base font-normal">{errors[name]}</span>}
    </div>
    </ClickAwayListener>
  )
}
